import React, { lazy } from 'react';
import LazySection from 'components/lazySection';
import SectionSkeleton from './sectionskeleton';
const CIOnsiteProject = lazy(() => import("components/Commercial-Industrial/onsite/ciOnsiteProject"));
const CIOnsiteSuccessStories = lazy(() => import("components/Commercial-Industrial/onsite/ciSuccesstories"));


const CommIndOnsiteBrand = lazy(() => import("components/Commercial-Industrial/onsite/cibrand"));
const CommIndOnsiteAbout = lazy(() => import("components/Commercial-Industrial/onsite/CommIndOnsiteAbout"));
const CommIndOnsiteSolutions = lazy(() => import("components/Commercial-Industrial/onsite/CommIndOnsiteSolutions "));
const CommIndOnsiteWhychoose = lazy(() => import("components/Commercial-Industrial/onsite/CommIndOnsiteWhychoose"));
const CommIndOnsiteBanner = lazy(() => import("components/Commercial-Industrial/onsite/CommIndOnsiteBanner"));




const CommIndOffsite: React.FC = () => {
  return (
    <>
   

     <CommIndOnsiteBanner />

      {/* Lazy load sections when visible */}
     <LazySection fallback={<SectionSkeleton height={400} />}>
        <CommIndOnsiteAbout />
      </LazySection>

    
      <LazySection fallback={<SectionSkeleton height={400} />}>
        <CommIndOnsiteWhychoose />
      </LazySection>

      <LazySection fallback={<SectionSkeleton height={400} />}>
        <CommIndOnsiteSolutions />
      </LazySection>
      
      <LazySection fallback={<SectionSkeleton height={400} />}>
        <CIOnsiteProject />
      </LazySection> 

      <LazySection fallback={<SectionSkeleton height={400} />}>
        <CIOnsiteSuccessStories />
      </LazySection>

       <LazySection fallback={<SectionSkeleton height={400} />}>
        <CommIndOnsiteBrand />
      </LazySection>
      
    </>
  );
};

export default CommIndOffsite;
